module.exports = __webpack_public_path__ + "static/media/17.cdea4abe.mp3";